import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';

import { LoginRoutes } from './login';
import { DocumentRoutes } from './document';
import { Main } from 'pages/Main';
import { ControlTower } from 'pages/ControlTower';
import { SettingsRoutes } from './settings';

const ExternalCronogramaRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(
      'https://app.smartsheet.com/sheets/G9R4XFGH4mG4MxXX26gfpr4c3RJ66PGGRQwg92v1?view=gantt'
    );
  }, []);
  return null;
};

export const Routes: React.FC = () => {
  return (
    <>
      <Switch>
        <PrivateRoute path="/" exact component={Main} />
        <PrivateRoute path="/base/base" exact component={Main} />
        <PrivateRoute path="/control-tower" exact component={ControlTower} />
        {/* Public route for /cronograma */}
        <Route
          path="/cronograma"
          exact
          component={ExternalCronogramaRedirect}
        />
      </Switch>
      <LoginRoutes />
      <SettingsRoutes />
      <DocumentRoutes />
    </>
  );
};
